import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'

const BaseSingleNavSquare = styled(Link)`
  width: 1rem;
  height: 1rem;
  margin: .1rem;
  background-color: lightgray;
  display: block;
  transition: all 0.3s;
  &:hover {
    background-color: ${(props) => props.color};
    background-image: linear-gradient(0deg, rgba(170, 170, 170, 1), rgba(170, 170, 170, 1));
    background-blend-mode: multiply;
  }
`

const SingleNavSquare = styled(({className, ...props}) => <BaseSingleNavSquare {...props} activeClassName={className} />)`
  background-color: ${(props) => props.activeColor};
  @media (min-width: 620px) {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:hover {
    background-blend-mode: soft-light;
  }
`;

export default SingleNavSquare



// WEBPACK FOOTER //
// ../components/styled/SingleNavSquare.js